import { Instance, types } from 'mobx-state-tree';

export const StoreLanguage = types.model({
  isoCode2: types.string,
  languageIso: types.string,
  locale: types.identifier
});

export type StoreLanguage = Instance<typeof StoreLanguage>;
